import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import InboxMessageProp from '../../../../../sections/inbox/propTypes/inboxMessageProp';
import { INBOX_MSG_TYPE } from '../../../../../services/utilityFunctions';
import RatingStars from '../../../../RatingStars';
import NotificationIcon from './NotificationIcon';
import NotificationMessage from './NotificationMessage';
import NotificationExtraBlock from './NotificationExtraBlock';
import UserProp from '../../../../propTypes/userProp';

export default function NotificationListItem({ notification, loggedUser }) {
  return (
    <div className="notification-list-item">
      <div
        className={`notification-list-item-unread-indicator ${
          notification.isBadgeRead ? 'read' : 'unread'
        }`}
      />
      <NotificationIcon notification={notification} loggedUser={loggedUser} />
      <div className="notification-list-item-content">
        <NotificationMessage
          notification={notification}
          loggedUser={loggedUser}
        />
        {notification.type === INBOX_MSG_TYPE.RATING && (
          <RatingStars value={notification.rating?.value || 0} />
        )}
        <NotificationExtraBlock notification={notification} />
        <div className="notification-list-item-date">
          {moment(notification.createdAt).format('DD MMM YYYY, HH:mm')}
        </div>
      </div>
    </div>
  );
}

NotificationListItem.propTypes = {
  notification: PropTypes.shape(InboxMessageProp.propTypes).isRequired,
  loggedUser: PropTypes.shape(UserProp.propType).isRequired,
};
